import Cookies from "universal-cookie";

export default class APIService {
	/**
	 * Call API to change password. Returns 0 on success, otherwise returns an error message.
	 * @param {*} netid
	 * @param {*} password
	 * @param {*} token
	 **/
	static async change_password(netid, password, token) {
		let body = {
			netid: netid,
			password: password,
			token: token
		};

		let cookies = new Cookies();

		let config = {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				"X-XSRF-TOKEN": cookies.get("XSRF-TOKEN")
			},
			method: "POST",
			body: JSON.stringify(body)
		};

		try {
			let response = await fetch(`/api/password/ChangePW`, config);
			let data = await response.json();
			return {ok: response.ok, ...data};
		} catch (error) {
			return { ok: false, error };
		}

	}

	/***
	 * Call API to validate a welcome token. On success, result
	 * object will include user info & a set password token.
	 *
	 */
	static async validate_token(token) {
		let config = {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			method: "GET"
		};

		try {
			let response = await fetch(`/api/token/validate?token=${token}`, config);
			let data = await response.json();
			return {ok: response.ok, ...data};
		} catch (error) {
			return { ok: false, error };
		}
	}

	/***
	 * Call API to send a verification code. 
	 *
	 */
	static async send_verification_code(netid, verificationOptionId) {
		let body = {
			netid: netid,
			verificationOptionId: verificationOptionId
		};

		let config = {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			method: "POST",
			body: JSON.stringify(body)
		};

		try {
			let response = await fetch(`/api/token/sendcode`, config);
			let data = await response.json();
			return {ok: response.ok, ...data};
		} catch (error) {
			return { ok: false, error };
		}
	}

	/***
	 * Call API to validate a verification code. On success, result
	 * object will include user info & a set password token.
	 *
	 */
	static async validate_verification_code(netid, code) {
		let body = {
			netid: netid,
			token: code
		};

		let config = {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			method: "POST",
			body: JSON.stringify(body)
		};



		try {
			let response = await fetch(`/api/token/validatecode`, config);
			let data = await response.json();
			return {ok: response.ok, ...data};
		} catch (error) {
			return { ok: false, error };
		}
	}


	static async get_verification_options(netid) {
		let config = {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			method: "GET"
		};

		try {
			let response = await fetch(`/api/verification/options?netid=${netid}`, config);
			let data = await response.json();
			return {ok: response.ok, ...data};
		} catch (error) {
			return { ok: false, error };
		}
	}

	static async get_version() {
		let config = {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			method: "GET"
		};

		try {
			let response = await fetch(`/api/version`, config);
			let data = await response.json();
			return {ok: response.ok, ...data};
		} catch (error) {
			return { ok: false, error };
		}
	}
	
	static async lookup(query) {
		let config = {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			method: "GET"
		};

		try {
			let response = await fetch(`api/user/lookup?query=${query}`, config);
			let data = await response.json();
			return {ok: response.ok, ...data};
		} catch (error) {
			return { ok: false, error };
		}
	}
}